<template>
  <div class="cuori" :class="{ small }" @click.stop>
    <button
      v-for="cuore in maxCuori"
      :key="cuore"
      type="button"
      class="cuori-btn"
      :class="{ 'cuori-btn--active': cuore <= value }"
      @click.stop="selectCuori(cuore)"
    >
      <v-icon>favorite</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "cuori",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    maxCuori: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    selectCuori(cuore) {
      this.$emit("input", this.value === cuore ? 0 : cuore);
    },
  },
};
</script>

<style lang="scss" scoped>
.cuori {
  align-items: center;
  display: inline-flex;
}

.cuori.small .cuori-btn {
  .v-icon {
    font-size: 25px;
  }
}

.cuori-btn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  padding: 0;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px var(--v-accent-base);
  }

  .v-icon {
    color: var(--v-navy-darken2);
    font-size: 28px;
    opacity: 0.7;
    transition: opacity 0.18s ease;
  }

  &:hover .v-icon {
    opacity: 1;
  }

  &.cuori-btn--active .v-icon {
    color: var(--v-error-base);
    opacity: 0.8;
  }

  &.cuori-btn--active:hover .v-icon {
    opacity: 1;
  }
}
</style>
